import React from 'react';
import ChampIcon from './ChampIcon.js'
import Graph from './Graph.js'
import Sort from './Sort.js'
import Cards from './Cards.js'

class Result extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      sortBy:"",
      Loaded1: false,
      Loaded2: false,
    }
  }

  setSort = (sort) => {
    this.setState({sortBy: sort});
  }

  setLoaded1 = (loadedStatus1) => {
    this.setState({Loaded1: true});
  }

  setLoaded2 = (loadedStatus2) => {
    this.setState({Loaded2: true});
  }

  render(){
    return(
      <div className = "result">
        <ChampIcon />
        <div className = "sortingbar">
          <Sort setSort={this.setSort}/>
        </div>
        <div className="graph">
          <Graph sort={this.state.sortBy} setLoaded1={this.setLoaded1}/>
        </div>
        <Cards sort={this.state.sortBy} setLoaded2={this.setLoaded2}/>
      </div>
    ) 
  }

}export default Result;